var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSoftNarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7488_7838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.706184 0.719401L4.82796 5.07087",
    stroke: "black",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86575 0.803048L5.12622 5.3758",
    stroke: "black",
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7488_7838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.91675,
    height: 6,
    fill: "white",
    transform: "translate(0.083252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSoftNarrow);
export default __webpack_public_path__ + "static/media/ArrowDownSoftNarrow.67dead7fdb7204380b693047af25c448.svg";
export { ForwardRef as ReactComponent };